<button
  type="{{ type }}"
  class="icp-button"
  [class.primary]="variant === 'primary' && !backgroundColor"
  [class.secondary]="variant === 'secondary' && !backgroundColor"
  [class.outline]="variant === 'outline' && !backgroundColor"
  [class.full-width]="fullWidth"
  [class.disabled]="disabled"
  [class.custom-colors]="backgroundColor || textColor"
  [style.background-color]="backgroundColor || null"
  [style.color]="textColor || null"
  [style.--hover-bg-color]="hoverBackgroundColor || null"
  [style.--hover-text-color]="hoverTextColor || null"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <icp-icon
    *ngIf="iconPosition === 'left' && (iconName || iconSrc)"
    [name]="iconName"
    [src]="iconSrc"
    [size]="20"
    class="button-icon-left"
  ></icp-icon>
  <span class="button-label">{{ label }}</span>
  <icp-icon
    *ngIf="iconPosition === 'right' && (iconName || iconSrc)"
    [name]="iconName"
    [src]="iconSrc"
    [size]="20"
    class="button-icon-right"
  ></icp-icon>
</button>

